import { render, staticRenderFns } from "./CompanyPrefixes.vue?vue&type=template&id=f3276d92&scoped=true&"
import script from "./CompanyPrefixes.vue?vue&type=script&lang=js&"
export * from "./CompanyPrefixes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3276d92",
  null
  
)

export default component.exports